let FJRatioStore = (function () {
  const RATIO_LANDSCAPE = "RATIO_LANDSCAPE";
  const RATIO_VERTICAL = "RATIO_VERTICAL";
  const RATIO_SQUARE = "RATIO_SQUARE";
  const RATIO_CINEMATIC = "RATIO_CINEMATIC";
  const RATIO_SOCIAL = "RATIO_SOCIAL";

  return {

    /**
     * @description 返回所有的比例类型
     * @return {{square: string, social: string, landscape: string, vertical: string, cinematic: string}}
     */
    allRatioType: function () {
      return {
        landscape: RATIO_LANDSCAPE,
        vertical: RATIO_VERTICAL,
        square: RATIO_SQUARE,
        cinematic: RATIO_CINEMATIC,
        social: RATIO_SOCIAL,
      }
    },

    /**
     * @description 返回所有的比例尺寸
     */
    allRatioSize: function () {
      return {
        landscape: {width: 1920, height: 1080},
        vertical: {width: 608, height: 1080},
        square: {width: 1080, height: 1080},
        cinematic: {width: 2520, height: 1080},
        social: {width: 864, height: 1080},
      }
    },

    /**
     * @description 返回所有的比例值
     * @return {{square: number, social: number, landscape: number, vertical: number, cinematic: number}}
     */
    allRatio: function () {
      return {
        landscape: 1.78,
        vertical: 0.56,
        square: 1,
        cinematic: 2.33,
        social: 0.8,
      }
    },

    /**
     * @description 返回指定type的字段
     * @param type
     * @return {string}
     */
    ratioKeyWithRatioType: function (type) {
      let allRatioType = this.allRatioType();
      let key = '';
      for (let i in allRatioType) {
        if (Object.hasOwnProperty.call(allRatioType, i)) {
          if (allRatioType[i] === type) {
            key = i;
          }
        }
      }

      return key;
    },

    /**
     * @description 返回指定type的size
     * @param type
     * @return {object}
     */
    ratioSizeWithRatioType: function (type) {
      return this.allRatioSize()[this.ratioKeyWithRatioType(type)];
    }
  }
})();

export default FJRatioStore;